// Registers every dayjs locale used by SUPPORTED_LANGUAGES. Import it for its side effects.
import "dayjs/locale/de";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/ja";
import "dayjs/locale/ko";
import "dayjs/locale/nl";
import "dayjs/locale/pl";
import "dayjs/locale/pt";
import "dayjs/locale/sv";
import "dayjs/locale/zh";
import "dayjs/locale/zh-tw";
